import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { updateRiskConfig } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const updateRiskConfigAction = createApi(updateRiskConfig, "PUT");

const updateRiskConfigSlice = createSlice({
  name: "updateRiskConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateRiskConfigAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRiskConfigAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateRiskConfigAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default updateRiskConfigSlice.reducer;
